export const buildMailToLink = (subject: string, body: string) => {
  const encodedSubject = encodeURIComponent(subject);
  const encodedBody = encodeURIComponent(body);

  return `mailto:?subject=${encodedSubject}&body=${encodedBody}`;
};
